const CtlGridLocale: any = {
    rownumber: " ",
    page: "页",
    more: "更多",
    to: "到",
    of: "of",
    next: "下一页",
    last: "上一页",
    first: "首页",
    previous: "上一页",
    loadingOoo: `<i class="fa fa-spinner fa-pulse"></i>`,
    selectAll: "查询全部",
    searchOoo: "查询...",
    blanks: "空白",
    filterOoo: "过滤...",
    applyFilter: "确定",
    clearFilter: "清空",
    equals: "相等",
    notEqual: "不相等",
    lessThan: "小于",
    greaterThan: "大于",
    lessThanOrEqual: "小于等于",
    greaterThanOrEqual: "大于等于",
    inRange: "范围查询",
    contains: "包含",
    notContains: "不包含",
    startsWith: "开始于",
    endsWith: "结束于",
    group: "组",
    columns: "列",
    filters: "筛选",
    rowGroupColumns: "laPivot Cols",
    rowGroupColumnsEmptyMessage: "la drag cols to group",
    valueColumns: "laValue Cols",
    pivotMode: "laPivot-Mode",
    groups: "laGroups",
    values: "值",
    pivots: "laPivots",
    valueColumnsEmptyMessage: "la drag cols to aggregate",
    pivotColumnsEmptyMessage: "la drag here to pivot",
    toolPanelButton: "la tool panel",
    noRowsToShow: "数据为空",
    pinColumn: "laPin Column",
    valueAggregation: "laValue Agg",
    autosizeThiscolumn: "laAutosize Diz",
    autosizeAllColumns: "laAutsoie em All",
    groupBy: "排序",
    ungroupBy: "不排序",
    resetColumns: "重置列",
    expandAll: "展开全部",
    collapseAll: "关闭",
    toolPanel: "工具面板",
    export: "导出",
    csvExport: "导出为CSV格式文件",
    excelExport: "导出到Excel",
    pinLeft: "laPin &lt;&lt;",
    pinRight: "laPin &gt;&gt;",
    noPin: "laDontPin &lt;&gt;",
    sum: "总数",
    min: "最小值",
    max: "最大值",
    none: "无",
    count: "总",
    average: "平均值",
    copy: "复制",
    copyWithHeaders: "携带表头复制",
    ctrlC: "ctrl + C",
    paste: "粘贴",
    ctrlV: "ctrl + V"
};

export default CtlGridLocale
